<script>
import Vue from 'vue'
import AgGridVendorColumns from '@/Mixins/SigmaClientNew/AgGridVendorColumns'
import { AgGridVue } from 'ag-grid-vue'
import GridAutocomplete from '@/components/SigmaClientNew/GridAutocomplete.vue'

export default Vue.extend({
  name: 'VendorList',

  components: {
    AgGridVue,
    GridAutocomplete
  },
  mixins: [ AgGridVendorColumns ],

  props: {
    // Name of input field.  Not really necessary, but helpful if we use the form object down the road
    name: {
      required: true,
      type: String
    },

    iteration: {
      required: true,
      type: Number
    },

    width: {
      required: true,
      type: String
    },

    height: {
      required: true,
      type: String
    },

    classes: {
      required: false,
      type: String,
      default: 'ag-theme-balham'
    },

    rowData: {
      required: false
    },

    columns: {
      required: false,
      type: Array,
      default: undefined
    },

    options: {
      required: false,
      type: Object,
      default: undefined
    }
  },

  data () {
    return {
      isError: false, // If the input or selected field is incorrect, show an error
      isLoading: false,
      scope: this,
      gridApi: null,
      columnApi: null,
      defaultColDefs: undefined,
      defaultGridOptions: undefined,
      allEntityTypes: [ 'NOT_1099', 'CORPORATION', 'LLC', 'LLC_CORP', 'LEGAL_FIRM', 'PARTNERSHIP', 'SOLE_PROPRIETOR_SSN', 'SOLE_PROPRIETOR_EIN', 'INDIVIDUAL', 'OTHER', 'UNKNOWN' ],
      taxableEntityTypes: [ 'LLC', 'LEGAL_FIRM', 'PARTNERSHIP', 'SOLE_PROPRIETOR_SSN', 'SOLE_PROPRIETOR_EIN', 'INDIVIDUAL', 'OTHER', 'UNKNOWN' ]
    }
  },

  computed: {
    columnDefs () {
      if (this.columns && Array.isArray(this.columns)) {
        return this.columns
      } else {
        return this.defaultColDefs
      }
    },
    gridOptions () {
      return this.options || this.defaultGridOptions
    }
  },

  methods: {
    onGridReady (params) {
      if (params) {
        this.gridApi = params.api
        this.columnApi = params.columnApi
      }
    },

    onFirstDataRendered (params) {
      // this.onChangeVisibleColumns()
      const el = (this.$refs[this.name] || {}).$el
      if (el.hidden !== false) params.api.sizeColumnsToFit()
      this.isLoading = false
      /*
      const rootNode = (params.api.getDisplayedRowAtIndex(0) || {}).parent
      if (rootNode && rootNode.aggData) params.api.setPinnedBottomRowData([rootNode.aggData]);
      */
    },

    onCellValueChanged (params) {
      // Ignore if not changed
      if (params.value && params.oldValue === params.newValue) return
      // params.api.redrawRows()             // Now we have to refresh the whole page
      // this.pinTotalRow(this.gridApi)
    },

    onChangeVisibleColumns () {
      this.$nextTick(() => {
        this.gridApi.sizeColumnsToFit()
      })
    },
    async save () {
      for (const i in this.rowData) {
        let vendor = this.rowData[i]
        if (Object.keys(vendor.changes).length) {
          try {
            await vendor.save()
            vendor.changes = {}
          } catch (apiError) {
            if (apiError.response.status === 404) {
              // this.$parent.addAlert('Error Saving', 'danger', true)
              console.log('Error Saving', 'danger', true)
            } else {
              // this.$parent.addAlert(apiError, 'danger', true)
              console.log(apiError, 'danger', true)
            }
            return false
          }
        }
      }
    }
  },
  beforeMount () {
    this.defaultColDefs = [
      this.vendorNumberColumn,
      this.vendorNameColumn,
      this.vendorPayeeNameColumn,
      this.vendorTaxIdColumn,
      this.vendorTypeColumn,
      this.vendorAddress1Column,
      this.vendorAddress2Column,
      this.vendorCityColumn,
      this.vendorStateColumn,
      this.vendorPostalColumn,
      this.vendorStatusColumn
    ]
    this.defaultGridOptions = {
      singleClickEdit: false,
      undoRedoCellEditing: false,
      enterMovesDown: true,
      enterMovesDownAfterEdit: true,
      rowSelection: 'multiple',
      columnDefs: this.columnDefs,
      defaultColDef: {
        resizable: true,
        menuTabs: []
      },
      frameworkComponents: {
        gridAutocomplete: GridAutocomplete
      },
      rowClassRules: {
        'ag-error': (params) => params.data && params.data.attributes && (params.data.attributes.entity_type === 'UNKNOWN' || (this.taxableEntityTypes.includes(params.data.attributes.entity_type) && !params.data.attributes.tax_id))
      },

      onGridReady: (params) => {
        this.onGridReady(params)
      },
      onFirstDataRendered: (params) => {
        this.onFirstDataRendered(params)
      },
      onCellValueChanged: (params) => {
        this.onCellValueChanged(params)
        // this.highlightCell()
      }
    }
  }
})
</script>

<template>
<div>
  <ag-grid-vue
    :name="name"
    :ref="name"
    :class="classes"
    :style="{ width, height }"
    :key="iteration"
    :column-defs="columnDefs"
    :row-data="rowData"
    :grid-options="gridOptions"
  />
</div>
</template>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/VendorList.vue